import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { combineLatest, filter, map, startWith, tap } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SvgIconComponent } from 'angular-svg-icon';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { GlobalStore } from 'src/app/store/global-store';
import { CountryCallingCode } from 'src/app/models/country-calling-code.model';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'que-phone-number-question-display',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ReactiveFormsModule, FormsModule, SvgIconComponent, OverlayModule],
    templateUrl: './phone-number-question-display.component.html',
    styleUrls: ['./phone-number-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneNumberQuestionDisplayComponent implements OnInit {
  @Input()
  question?: Question;
  @Input()
  isPreview = false;
  @Input()
  modularOrder?: number;
  @Input() modularId?: string;
  @Input() viewAnswer = false;

  searchControl = new FormControl<string>('', [Validators.pattern('^[0-9 ]{0,5}$')]);
  isSelectOpen = false;

  @ViewChild('trigger') trigger!: ElementRef;
  #builder = inject(FormBuilder);

  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));
  isUser$ = this.#questionnaireStore.isUserSig$;
  isDisableSignal$ = toSignal(this.isNotUser$)

  readonly positonArea = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }] as ConnectedPosition[];
  // @ViewChild('inputElement') inputElement: ElementRef | undefined;

  myAnswer?: Answer;

  prevValue: string | null = "";
  prevSearchValue: string | null = "";
  #answerStore = inject(AnswersStore);
  #globalStore = inject(GlobalStore);

  answerForm = this.#builder.group({
    dialCode: new FormControl<string>("+972"),
    answer: new FormControl<string>(''),
  });


  countryCallingCode$ = this.#globalStore.countryCallingCode$;
  filteredOptions$ = combineLatest(this.countryCallingCode$, this.searchControl.valueChanges.pipe(startWith(""))).pipe(
    map(([countryCallingCode, search]) => this._filter(countryCallingCode, search as string))
  )
  eventDeleteModularuestionId$ = this.#answerStore.eventDeleteModularuestionId$;

  ngOnInit(): void {
    if (this.question?.requierd) {
      this.answerForm.controls.answer.setValidators(Validators.required);
      this.answerForm.controls.dialCode.setValidators(Validators.required);
    }
    this.isNotUser$.subscribe((isNotUser) => {
      if (isNotUser) {
        this.answerForm.disable();
      } else {
        this.answerForm.enable();
      }
    });

    this.eventDeleteModularuestionId$.pipe(filter(id => id != undefined && id == this.question?.id)).subscribe(
      x => {
        this.getAnswers()
      }
    )


    this.answerForm.valueChanges.subscribe(
      ans => {
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, modularQuestionGuid: this.modularId, modularRowNum: this.modularOrder, textAnswer: ans.answer ?? '', multiOptionsAnswer: ans.dialCode ?? '', isValid: this.answerForm.valid })
      });

    this.getAnswers();
  }

  private _filter(
    countryCallingCode: CountryCallingCode[],
    name: string
  ): CountryCallingCode[] {
    const filterValue = name?.toLowerCase();
    return countryCallingCode.filter(
      (option) =>
        option.dialCode.toLowerCase().includes(filterValue)
    );
  }


  onInput(event: any) {
    if (event.data != null) {
      // const inputValue = this.inputElement?.nativeElement.value;
      const inputValue = this.answerForm.controls.answer.value;
      if (inputValue)
      // Check if the input is valid (you can use your existing custom validator)
      {
        if (!this.isValidPhoneNumber(inputValue)) {
          this.answerForm.controls.answer.setValue(this.prevValue);
        }
      }
    }
    this.prevValue = this.answerForm.controls.answer.value;
  }

  onInputSelect(event: any) {
    if (event.data != null) {
      // const inputValue = this.inputElement?.nativeElement.value;
      const inputValue = this.searchControl.value;
      if (inputValue)
      // Check if the input is valid (you can use your existing custom validator)
      {
        if (!this.searchControl.valid) {
          this.searchControl.setValue(this.prevSearchValue);
        }
      }
    }
    this.prevSearchValue = this.searchControl.value;
  }


  isValidPhoneNumber(phoneNumber: string) {
    const inputReplac = phoneNumber.replace(/-/g, '');
    var isValid = /^(\d{0,12})$/.test(inputReplac);
    //תקין זה אומר ספרות בלבד ואפשרות ל- אחרי 2 ספרות ו/או אחרי 5
    if (phoneNumber.indexOf('-') != -1) {
      if (phoneNumber.indexOf('-') == 2) {
        const inputReplacFirst = phoneNumber.replace("-", '');
        if (inputReplacFirst.indexOf("-") != -1) {
          const inputReplacSecond = inputReplacFirst.replace("-", '');
          if (inputReplacFirst.indexOf("-") != 5 || inputReplacSecond.indexOf("-") != -1)
            isValid = false;
        }
      }
      else
        if (phoneNumber.indexOf("-") == 5) {
          const inputReplacFirst = phoneNumber.replace("-", '');
          if (inputReplacFirst.indexOf("-") != -1)
            isValid = false;
        }
        else {
          isValid = false;
        }
    }
    return isValid;
  }

  getAnswers() {
    this.#answerStore.answers$.pipe(
      map(arr => arr.find(ans => (ans.questionId == this.question?.id && (!this.modularId || (ans.modularQuestionGuid == this.modularId && ans.modularRowNum == this.modularOrder)))))
    ).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        if (x.textAnswer) {
          this.answerForm.controls.answer.setValue(x.textAnswer, { emitEvent: false });
          this.prevValue = x.textAnswer;
        }
        // if (x.secondaryTextAnswer) {
        //   this.answerForm.controls.dialCode.setValue(x.secondaryTextAnswer, { emitEvent: false });
        // }
        if (x.multiOptionsAnswer)
          this.answerForm.controls.dialCode.setValue(x.multiOptionsAnswer, { emitEvent: false });
      }
    }).unsubscribe();
  }

  updateSelection(op: CountryCallingCode) {
    this.answerForm.controls.dialCode.setValue(op.dialCode);
    this.closeSelect();
  }
  closeSelect() {
    this.searchControl.setValue(null);
    this.isSelectOpen = false;
  }

  openSelect() {
    if (this.isPreview || this.isUser$()) {
      const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      // Check if the menu would open out of the viewport
      if (triggerRect.bottom + 200 > viewportHeight) { // assuming 200px height for the menu
        this.positonArea[0].overlayY = 'bottom';
      } else {
        this.positonArea[0].overlayY = 'top';
      }
      this.isSelectOpen = true;
    }
  }
}
